import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../-routeParams';

const title = i18n.t(($) => $.form.pageTitle.create, { ns: 'contract' });

export const Route = createFileRoute('/(main)/demand/contracts/create/')({
  head: () => getRouteHead(title, 'Erstelle einen neuen Vertrag in VESTIGAS'),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const DEMAND_CONTRACT_CREATE = buildRouteExport({
  Route,
  ...routeParams,
});
